module.exports = __webpack_public_path__ + "static/media/ins-bg-tablet.4725b946.jpg";